import * as React from 'react'

export const Triangle = () => (
  <svg
    width="6px"
    height="7px"
    viewBox="40 0 6 7"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon
      id="Triangle"
      stroke="none"
      fill="rgba(0, 0, 0, .2)"
      fillRule="evenodd"
      points="40 7 40 0 46 3.5"
    />
  </svg>
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Icons/Triangle.tsx